import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Navimumbaitointernatinalcabservice() {



  const cardData = {
    keyword: " Navi Mumbai to Ashtavinayak Cab Service  ",


"headingDescription": "Royal Route Cab offers reliable Navi Mumbai to Ashtavinayak cab service, providing safe, comfortable, and spiritually fulfilling travel for families, devotees, and group pilgrims. The Ashtavinayak Yatra covers eight sacred temples of Lord Ganesha located across Maharashtra, typically completed over 2–3 days with a well-planned route. Our professional drivers ensure a smooth and hassle-free journey with timely pickups, temple route expertise, and well-maintained vehicles. We offer customized Ashtavinayak tour packages including one-way, round trip, and multi-day pilgrimage plans. Our fleet includes air-conditioned sedans, SUVs, Innova, Ertiga, Kia Carens, Innova Crysta, and Tempo Travellers suitable for all group sizes. With 24/7 availability, transparent pricing, and easy booking, Royal Route Cab is your trusted choice for Navi Mumbai to Ashtavinayak cab service.",

"topPlaces": [
  {
    "title": "Mayureshwar Temple (Morgaon)",
    "description": "Mayureshwar Temple at Morgaon is considered the starting and ending point of the Ashtavinayak Yatra. Dedicated to Lord Ganesha as Mayureshwar, the temple holds immense spiritual importance and is believed to fulfill devotees’ wishes. The temple architecture reflects traditional design with a peaceful ambiance that attracts thousands of pilgrims. Devotees usually begin their journey here and also conclude the yatra at the same temple, completing the sacred cycle. The surrounding village atmosphere adds to the spiritual charm, making it a deeply devotional experience."
  },
  {
    "title": "Siddhivinayak Temple (Siddhatek)",
    "description": "Siddhivinayak Temple at Siddhatek is located on the banks of the Bhima River and is known for its unique right-trunk Ganesha idol. It is believed that Lord Vishnu worshipped Ganesha here to gain success in defeating demons. Devotees perform pradakshina (circumambulation) of the hill, which is considered highly auspicious. The serene riverside setting and calm surroundings enhance the spiritual experience, making it an important stop in the Ashtavinayak circuit."
  },
  {
    "title": "Ballaleshwar Temple (Pali)",
    "description": "Ballaleshwar Temple in Pali is the only Ashtavinayak temple named after a devotee, Ballal, who was a great follower of Lord Ganesha. The temple architecture is designed in such a way that the sun’s rays fall directly on the idol during specific times of the year. It is a major pilgrimage site where devotees seek blessings for devotion and dedication. The temple is easily accessible and often crowded with pilgrims throughout the year."
  },
  {
    "title": "Varadvinayak Temple (Mahad)",
    "description": "Varadvinayak Temple at Mahad is known as the temple of blessings and boons. Devotees believe that prayers offered here fulfill desires and bring prosperity. The temple allows devotees to enter the sanctum and directly worship the idol, which is a unique feature compared to many other temples. The peaceful surroundings and spiritual atmosphere make it a significant stop during the yatra."
  },
  {
    "title": "Chintamani Temple (Theur)",
    "description": "Chintamani Temple at Theur is associated with the story of Lord Ganesha removing worries and granting peace of mind. Devotees visit this temple to seek relief from stress, anxiety, and life problems. The temple is surrounded by greenery and offers a calm environment, making it a spiritually soothing destination. It is one of the most visited temples in the Ashtavinayak route due to its accessibility and importance."
  },
  {
    "title": "Girijatmaj Temple (Lenyadri)",
    "description": "Girijatmaj Temple at Lenyadri is located inside a series of rock-cut caves on a hill and is the only Ashtavinayak temple situated in a mountain cave. Devotees need to climb around 300 steps to reach the temple, making it both a spiritual and physical journey. The temple is believed to be the place where Goddess Parvati performed penance to have Lord Ganesha as her son. The scenic surroundings and unique cave setting make it a memorable part of the yatra."
  },
  {
    "title": "Vighnahar Temple (Ozar)",
    "description": "Vighnahar Temple at Ozar is dedicated to Lord Ganesha as the remover of obstacles. The temple is known for its beautiful architecture, golden dome, and peaceful environment. Devotees visit this temple to seek blessings for success and removal of difficulties in life. The well-maintained temple परिसर and festive celebrations make it a vibrant spiritual destination."
  },
  {
    "title": "Mahaganpati Temple (Ranjangaon)",
    "description": "Mahaganpati Temple at Ranjangaon is considered one of the most powerful forms of Lord Ganesha. It is believed that Lord Shiva worshipped Ganesha here before defeating the demon Tripurasura. The temple has deep spiritual significance and attracts devotees seeking strength and protection. The idol is said to be hidden in a secret chamber, adding to the temple’s mystery and importance."
  },
  {
    "title": "Multi-Day Yatra Planning",
    "description": "The Ashtavinayak Yatra is usually completed over 2–3 days with a well-planned route covering all eight temples efficiently. Cab services provide experienced drivers familiar with the temple sequence, helping devotees save time and avoid confusion. Travelers can choose customized packages with hotel stays, food stops, and flexible timing for darshan at each temple. This ensures a smooth, comfortable, and spiritually fulfilling journey without travel stress."
  },
  {
    "title": "Comfortable Group Travel",
    "description": "For Ashtavinayak pilgrimage, vehicles like Innova, Ertiga, and Tempo Travellers are ideal for group travel, offering comfortable seating and enough space for long journeys. Families and groups can travel together conveniently, enhancing the spiritual experience. The availability of air-conditioned vehicles and professional drivers ensures a relaxed journey across all temple locations, even during long travel hours."
  }
],






services: [
  {
    name: "Navi Mumbai to Ashtavinayak Cab",
    description: "Navi Mumbai to Ashtavinayak cab service offers a comfortable and spiritual journey covering all eight sacred Ganpati temples in Maharashtra. Ideal for families and devotees, this service ensures smooth travel with experienced drivers. Clean vehicles enhance comfort. It guarantees a peaceful yatra experience."
  },
  {
    name: "Navi Mumbai Ashtavinayak Darshan Cab",
    description: "Navi Mumbai Ashtavinayak Darshan cab provides complete travel solutions for visiting all eight temples in a planned route. This service is perfect for religious trips and group travel. Professional drivers ensure smooth navigation. It guarantees a hassle-free darshan journey."
  },
  {
    name: "Ashtavinayak Cab Service from Navi Mumbai",
    description: "Ashtavinayak cab service from Navi Mumbai ensures reliable transportation with well-maintained vehicles and trained drivers. Ideal for long-distance temple tours. Flexible booking enhances convenience. It ensures a safe and comfortable journey."
  },
  {
    name: "Navi Mumbai to Ashtavinayak Taxi",
    description: "Navi Mumbai to Ashtavinayak taxi offers private and flexible travel for pilgrims. This service includes door-to-door pickup and planned temple visits. Comfortable seating ensures a pleasant ride. It guarantees a smooth experience."
  },
  {
    name: "Ashtavinayak Yatra Cab from Navi Mumbai",
    description: "Ashtavinayak yatra cab from Navi Mumbai is designed for devotees seeking a spiritual road trip covering all Ganpati temples. Experienced drivers ensure proper route planning. Comfortable vehicles enhance travel experience. It guarantees a fulfilling pilgrimage."
  },
  {
    name: "Navi Mumbai to Ashtavinayak Taxi Service",
    description: "Navi Mumbai to Ashtavinayak taxi service provides dependable travel with flexible scheduling for temple visits. Ideal for families and groups. Professional drivers ensure safety. It guarantees a peaceful journey."
  },
  {
    name: "Ashtavinayak Taxi Booking Navi Mumbai",
    description: "Ashtavinayak taxi booking Navi Mumbai allows easy reservation with instant confirmation. Customers can choose vehicle type and travel plan. Transparent pricing ensures trust. It simplifies yatra planning."
  },
  {
    name: "AC Cab for Ashtavinayak from Navi Mumbai",
    description: "AC cab for Ashtavinayak from Navi Mumbai offers comfortable travel in air-conditioned vehicles. Ideal for long-distance temple tours in all weather conditions. Spacious seating enhances comfort. It guarantees a pleasant journey."
  },
  {
    name: "Round Trip Cab Navi Mumbai to Ashtavinayak",
    description: "Round trip cab Navi Mumbai to Ashtavinayak provides complete travel solutions including return journey. Ideal for multi-day pilgrimage trips. Flexible schedules enhance convenience. It ensures a hassle-free experience."
  },
  {
    name: "One Day Ashtavinayak Cab from Navi Mumbai",
    description: "One day Ashtavinayak cab from Navi Mumbai is perfect for quick darshan trips covering key temples. Efficient route planning ensures maximum coverage in limited time. Professional drivers ensure punctuality. It guarantees a smooth journey."
  },
  {
    name: "Ashtavinayak Darshan Cab Booking",
    description: "Ashtavinayak darshan cab booking provides easy and fast reservation for temple tours. Customers can select preferred vehicle and schedule. Instant confirmation ensures availability. It simplifies travel arrangements."
  },
  {
    name: "Ganpati Darshan Cab from Navi Mumbai",
    description: "Ganpati darshan cab from Navi Mumbai offers comfortable travel for visiting famous Ganpati temples. Ideal for devotees and families. Clean vehicles and experienced drivers ensure safety. It guarantees a peaceful darshan experience."
  },
  {
    name: "Ashtavinayak Yatra Taxi Service",
    description: "Ashtavinayak yatra taxi service provides reliable transportation for complete temple tours. This service ensures comfortable travel with proper route planning. Ideal for religious trips. It guarantees a fulfilling pilgrimage experience."
  }
],

tableData: [
  ["Navi Mumbai to Ashtavinayak Cab", "Navi Mumbai Ashtavinayak Darshan Cab"],
  ["Ashtavinayak Cab Service from Navi Mumbai", "Navi Mumbai to Ashtavinayak Taxi"],
  ["Ashtavinayak Yatra Cab from Navi Mumbai", "Navi Mumbai to Ashtavinayak Taxi Service"],
  ["Ashtavinayak Taxi Booking Navi Mumbai", "AC Cab for Ashtavinayak from Navi Mumbai"],
  ["Round Trip Cab Navi Mumbai to Ashtavinayak", "One Day Ashtavinayak Cab from Navi Mumbai"],
  ["Ashtavinayak Darshan Cab Booking", "Ganpati Darshan Cab from Navi Mumbai"],
  ["Ashtavinayak Yatra Taxi Service", ""]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Navi Mumbai to Ashtavinayak Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and comfortable Navi Mumbai to Ashtavinayak cab service, ideal for religious yatra and family travel."
  },
  {
    WhyChooseheading: "Complete Ashtavinayak Darshan Package",
    WhyChoosedescription: "We provide well-planned cab packages covering all 8 Ashtavinayak temples including Morgaon, Siddhatek, Pali, Mahad, Theur, Lenyadri, Ozar, and Ranjangaon."
  },
  {
    WhyChooseheading: "Experienced Temple Route Drivers",
    WhyChoosedescription: "Our drivers are experienced in pilgrimage routes, ensuring safe driving and smooth navigation across all temple locations."
  },
  {
    WhyChooseheading: "Perfect for 2–3 Day Yatra Plan",
    WhyChoosedescription: "Ashtavinayak darshan is usually completed in 2–3 days, and we offer flexible travel plans for a comfortable spiritual journey."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear pricing including tolls, driver allowance, and all travel costs with no hidden charges."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Choose from round-trip darshan packages or customized multi-day travel plans as per your convenience."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for group pilgrimage travel."
  },
  {
    WhyChooseheading: "Trusted Religious Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by devotees for Navi Mumbai to Ashtavinayak cab bookings due to reliable service and professional drivers."
  }
]

};

const faqData = [
  { question: "Do you provide Navi Mumbai to Ashtavinayak cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services for complete Ashtavinayak darshan from Navi Mumbai." },
  { question: "How many days are required for Ashtavinayak darshan?", answer: "Ashtavinayak yatra usually takes 2 to 3 days to complete all 8 temples." },
  { question: "What is the distance for Ashtavinayak tour?", answer: "The total travel distance is approximately 600 to 700 km depending on route." },
  { question: "What is the taxi fare for this tour?", answer: "Cab fare starts from ₹9000 to ₹15000 depending on vehicle type and duration." },
  { question: "Which vehicles are available?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Do you provide driver for entire trip?", answer: "Yes, all bookings include experienced drivers for the complete yatra." },
  { question: "Is this suitable for family travel?", answer: "Yes, it is ideal for family and group pilgrimage trips." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended especially during weekends and festive seasons." },
  { question: "Do you provide customized packages?", answer: "Yes, we offer fully customizable travel plans based on your schedule." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Prasad Joshi",
    feedback: "The Navi Mumbai to Ashtavinayak darshan trip with Royal Route Cabs was very peaceful and well-organized. The driver managed all temple visits smoothly and comfortably.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Meenal Kulkarni",
    feedback: "Excellent spiritual journey for Ashtavinayak darshan from Navi Mumbai. The cab was clean, the ride was comfortable, and the entire trip felt stress-free and well-planned.",
    rating: 5
  }
];







  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai to Ashtavinayak Cab Service",
  "image": "https://www.royalroutecabs.com/assets/images/navi-mumbai-to-ashtavinayak-cab.jpg", // replace if needed
  "description": "Book Navi Mumbai to Ashtavinayak Darshan cab service with Royal Route Cabs for a comfortable and spiritual pilgrimage tour covering all Ashtavinayak temples. Available for one-day and round-trip packages with Innova, Ertiga, SUV, and AC cab options.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "2800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5999", // indicative package fare (adjust as needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/navi-mumbai-to-ashtavinayak-cab"
  }
};







  return (
    <div>
<Helmet>
  <title>Navi Mumbai to Ashtavinayak Cab Service | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Navi Mumbai to Ashtavinayak cab service for Ganpati Darshan tour with Royal Route Cabs. One-day and round-trip packages with comfortable AC cabs, Innova, Ertiga, and SUV options."
  />

  <meta
    name="keywords"
    content="navi mumbai to ashtavinayak cab, navi mumbai ashtavinayak darshan cab, ashtavinayak cab service from navi mumbai, navi mumbai to ashtavinayak taxi, ashtavinayak yatra cab from navi mumbai, navi mumbai to ashtavinayak taxi service, ashtavinayak taxi booking navi mumbai, ac cab for ashtavinayak from navi mumbai, round trip cab navi mumbai to ashtavinayak, one day ashtavinayak cab from navi mumbai, ashtavinayak darshan cab booking, ganpati darshan cab from navi mumbai, ashtavinayak yatra taxi service, ashtavinayak ganpati tour cab, ashtavinayak darshan one day cab, innova cab navi mumbai to ashtavinayak, ertiga cab for ashtavinayak darshan, navi mumbai to ashtavinayak cab fare, ashtavinayak cab package navi mumbai, cheap cab to ashtavinayak from navi mumbai, best cab service ashtavinayak"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/88.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaitointernatinalcabservice;